import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { CheckList } from './types'

export const selectCheckList = (state: RootState): CheckList =>
  state.masterDocument.CheckList

export const selectEvent = (state: RootState): Event =>
  state.masterDocument.Event
